<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <span class="decoration"> Documents</span>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <span class="decoration">Manage Documents</span>
      </h6>

      <div class="container-fluid">
        <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">
          <div class="d-flex mb-1">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input
                v-model="search"
                type="search"
                placeholder="Search"
                class="bdr-rad"
              ></b-form-input>
            </b-input-group>
            <div style="margin-top: 11px;" class="ms-2"><span class="custom-breadcrumb">Showing {{ filteredAssignments.length }} items.</span></div>
          </div>
          <div class="d-grid  d-md-flex justify-content-md-end">
            <router-link
              to="/document/bulk-create"
              class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad font-size_def"
              >Bulk Upload</router-link
            >
            <router-link
              to="/document/create"
              class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad font-size_def"
              >Create</router-link
            >
          </div>
        </div>

        <div class="card bdr-rad2 shadow p-2">
          <div class="card-body mb-5">
            <div v-if="errorMessage" class="alert alert-danger py-2">
              {{ errorMessage }}
            </div>
            <div v-if="isLoading" class="text-center">
              <div class="spinner-border text-primary"></div>
            </div>
            <div v-else class="table-responsive">
              <b-table
                small
                hover
                show-empty
                style="font-size: small;"
                class="table-hover"
                :items="filteredAssignments"
                :fields="fields"
                head-variant="dark"
              >
                <template #cell(number)="row">{{ row.index + 1 }}</template>
                <template #cell(files)="row">
                  <div v-if="row.item.files.length" class="stacked-values">
                    <a
                      v-for="file in row.item.files"
                      :key="file"
                      :href="fileUrl(file)"
                      target="_blank"
                      >{{ fileName(file) }}</a
                    >
                  </div>
                  <span v-else>-</span>
                </template>
                <template #cell(status)="row">{{
                  row.item.status === 1 ? "Active" : "Inactive"
                }}</template>
                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad font-size_def" type="button" data-toggle="dropdown" aria-expanded="false">Action</button>
                    <div class="dropdown-menu bdr-rad">
                      <router-link class="dropdown-item mouse-cursor" :to="'/document/view?id=' + row.item.id">View</router-link>
                      <router-link class="dropdown-item mouse-cursor" :to="'/document/update?id=' + row.item.id">Update</router-link>
                    </div>
                  </div>
                </template>
                <template #empty
                  ><div class="text-center">No documents found.</div></template
                >
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      search: "",
      assignments: [],
      isLoading: true,
      errorMessage: "",
      fields: [
        { key: "number", label: "#" },
        { key: "job_title", label: "Document Title" },
        { key: "document_type", label: "Document Type" },
        { key: "employee", label: "People" },
        { key: "company", label: "Company" },
        { key: "department", label: "Department" },
        { key: "branch", label: "Branch" },
        { key: "files", label: "File Upload" },
        { key: "created_date", label: "Created Date" },
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    filteredAssignments() {
      const value = this.search.trim().toLowerCase();
      if (!value) return this.assignments;
      return this.assignments.filter((item) =>
        [item.job_title, item.document_type, item.employee, item.created_date]
          .join(" ")
          .toLowerCase()
          .includes(value)
      );
    },
  },
  mounted() {
    this.loadAssignments();
  },
  methods: {
    async loadAssignments() {
      try {
        const { data } = await axios.get("/document/job-assignments", {
          headers: { Authorization: "Bearer " + this.token },
        });
        this.assignments = (data.data || []).map((item) => ({
          ...item,
          files: item.files || [],
          links: item.links || [],
        }));
      } catch (error) {
        this.errorMessage = "Unable to load documents.";
      } finally {
        this.isLoading = false;
      }
    },
    fileUrl(file) {
      if (!file) return "";
      if (/^https?:\/\//i.test(file)) return file;
      return window.location.origin + "/" + String(file).replace(/^\/+/, "");
    },
    fileName(file) {
      return file.split("/").pop();
    },
  },
};
</script>
